/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/repos/bic-vue/src/components/common/ModalComponent.vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex h-full bg-white"
};
const _hoisted_2 = {
  class: "self-center"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "flex flex-col h-[80vh] 2xl:h-[600px]"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "my-6 text-xl text-center"
}, "Your design has been added to the cart!", -1);
const _hoisted_6 = {
  class: "flex mx-2"
};
const _hoisted_7 = {
  class: "ml-auto"
};
const _hoisted_8 = {
  class: "mx-2"
};
const _hoisted_9 = {
  class: "text-sm opacity-80"
};
const _hoisted_10 = {
  class: "flex mx-2 mt-auto"
};
const _hoisted_11 = {
  class: "ml-auto"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Pay less for more", -1);
const _hoisted_13 = {
  class: "hover:bg-base-100 pl-1"
};
const _hoisted_14 = {
  class: "label cursor-pointer"
};
const _hoisted_15 = {
  class: "label-text"
};
const _hoisted_16 = ["checked"];
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  class: "modal-action mt-8 md:mt-auto"
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", {
  href: "/cart",
  class: "btn btn-primary !text-white mr-2"
}, "Go to cart", -1);
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-neutral"
}, "Close", -1);
const _hoisted_22 = [_hoisted_20, _hoisted_21];
import useWPClient from '@/composables/services/useWPClient';
import { useCartStore } from '@/stores/cart';
import { useConfigurationStore } from '@/stores/configurationModule';
import { slugToLabelWithUnits, slugToMaterialColors } from '@/box/utils/unserialize-slug';
import { normalizePrice, formatPrice } from '@/utils/common';
export default {
  __name: 'AddToCartModal',
  setup(__props) {
    const $eventBus = inject('bus');
    const WPClient = useWPClient();
    const cartStore = useCartStore();
    const {
      nextLowerPrice,
      currentProductPrice,
      isUpsellUsed
    } = storeToRefs(cartStore);
    const configurationStore = useConfigurationStore();
    const {
      setBoxQuantity
    } = configurationStore;
    const {
      configurationScreenshotData,
      boxQuantity,
      product,
      configurationId
    } = storeToRefs(configurationStore);
    const currentActiveOffer = ref('default');
    const updating = ref(false);
    const updatingPrice = ref(false);
    async function onCLickHandleSelectedCartOption(option) {
      updating.value = true;
      try {
        currentActiveOffer.value = option;
        const payload = {
          product_id: product.value.id,
          meta_data: {
            configuration_id: configurationId.value
          },
          quantity: nextLowerPrice.value.min,
          is_upsell: option === 'upsell'
        };
        await WPClient.updateItemQuantity(payload);
      } catch (error) {
        console.error('updating quantity', error);
      } finally {
        updating.value = false;
      }
      // Handle quantity update
    }
    async function onFormAction() {
      if (currentActiveOffer.value === 'default') {
        return;
      }

      // Update only when upsell is selected
      try {
        updatingPrice.value = true;
        // update cart
        const cartItems = await WPClient.getCartItems();
        const {
          setCart
        } = cartStore;
        if (cartItems && cartItems.length !== 0) {
          setCart(cartItems);
          const cartItem = cartItems.find(item => item?.meta_data?.configuration_id === configurationId.value);
          if (cartItem) {
            setBoxQuantity(cartItem?.quantity);
          }
        }
      } catch (error) {
        console.error('Closing add-to-cart modal error', error);
      } finally {
        currentActiveOffer.value = 'default';
        updatingPrice.value = false;
      }
    }
    onMounted(() => {
      $eventBus.$on('open-add-to-cart-modal', () => {
        add_to_cart_modal.showModal();
      });
    });
    onBeforeUnmount(() => {
      $eventBus.$off('open-add-to-cart-modal');
    });
    return (_ctx, _cache) => {
      const _component_ModalComponent = __unplugin_components_0;
      return _openBlock(), _createBlock(_component_ModalComponent, {
        name: "add_to_cart_modal"
      }, {
        image: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
          src: _unref(configurationScreenshotData),
          class: "w-full h-auto object-cover"
        }, null, 8, _hoisted_3)])])]),
        content: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => onCLickHandleSelectedCartOption('default'), ["stop"])),
          class: _normalizeClass(["flex flex-col mt-4 p-2 border-[rgba(255,255,255,0.6)] border-[1px] rounded-lg cursor-pointer", {
            'border-purple-600': _unref(currentActiveOffer) === 'default',
            'hover:border-purple-400': !_unref(currentActiveOffer) === 'default'
          }])
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", null, _toDisplayString(_unref(slugToLabelWithUnits)(_unref(product)?.variation_slug)), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(formatPrice)(_unref(currentProductPrice))), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(_unref(slugToMaterialColors)(_unref(product)?.variation_slug)), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, _toDisplayString(_unref(boxQuantity)) + " pcs", 1), _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(formatPrice)(_unref(normalizePrice)(_unref(boxQuantity) * _unref(currentProductPrice)))), 1)])], 2), _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => onCLickHandleSelectedCartOption('upsell'), ["stop"])),
          class: _normalizeClass(["mt-4 p-2 border-[rgba(255,255,255,0.6)] border-[1px] rounded-lg cursor-pointer", {
            'border-purple-600': _unref(currentActiveOffer) === 'upsell',
            'hover:border-purple-400': !_unref(currentActiveOffer) === 'upsell'
          }])
        }, [_unref(nextLowerPrice) && _unref(nextLowerPrice).min ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [!_unref(isUpsellUsed) || true ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("label", _hoisted_14, [_createElementVNode("span", _hoisted_15, " Qty. " + _toDisplayString(_unref(nextLowerPrice).min) + ", " + _toDisplayString(_unref(formatPrice)(_unref(nextLowerPrice).price)) + " each - Total " + _toDisplayString(_unref(formatPrice)(_unref(normalizePrice)(_unref(nextLowerPrice).min * _unref(nextLowerPrice).price))), 1), _createElementVNode("span", {
          class: _normalizeClass(["relative radio after:content-[''] p-1 after:absolute after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:w-2/3 after:h-2/3 after:rounded-full", {
            'after:bg-purple-600': _unref(currentActiveOffer) === 'upsell',
            'border-purple-600': _unref(currentActiveOffer) === 'upsell'
          }]),
          name: "radio-quantity",
          checked: _unref(currentActiveOffer) === 'upsell'
        }, null, 10, _hoisted_16)])])], 64)) : (_openBlock(), _createElementBlock("p", _hoisted_17, "Upsell is used for this product"))], 64)) : (_openBlock(), _createElementBlock("p", _hoisted_18, "Contact us for a better deal."))], 2), _createElementVNode("div", _hoisted_19, [_createElementVNode("form", {
          method: "dialog",
          onSubmit: onFormAction
        }, _hoisted_22, 32)])])]),
        _: 1
      });
    };
  }
};